// @flow
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { formatDate, slugify, stripTags } from 'Utils/index';
import { Chessboard, ChessboardItem } from 'Components/Chessboard';
import Button from 'Components/Button';
import IntroText from 'Components/IntroText';
import ListModel from 'Stores/ListModel';
import NewsModel from 'Stores/NewsModel';
import classNames from 'classnames';
import styles from './styles.scss';

type Props = {
  newsList: Array<Object>,
  deeplinkId?: number,
};

type State = {
  newsList: ListModel,
};

export default class NewsList extends React.Component<Props, State> {
  static defaultProps = {
    newsList: [],
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      newsList: new ListModel(props.newsList, NewsModel),
    };
  }

  rendenEntry(entry: NewsModel, index: number) {
    const { newsList } = this.props;

    const words = stripTags(entry.text, '<sup>').split(' ');
    let content = words.slice(0, 30);
    content = content.join(' ') + (words.length > 30 ? '...' : '');

    const itemClassName = classNames(styles.newsitem, {
      [styles['top']]: entry.isTop,
    });

    const moreLink = `/ueber-uns/autohaus/events-und-news/${entry.id}-${slugify(entry.title)}/`;

    return (
      <ChessboardItem
        key={entry.id}
        entry={entry}
        className={itemClassName}
        consumptionText={newsList[index].consumptionText}
        consumptionColorType="white"
      >
        {!entry.isTop && (
          <h5>
            {entry.type === 'news' && (
              <Fragment>
                {entry.type} {formatDate(entry.datePublished)}
              </Fragment>
            )}
            {entry.type === 'event' && (
              <Fragment>
                {entry.type} {formatDate(entry.startDate)} - {formatDate(entry.endDate)}
              </Fragment>
            )}
          </h5>
        )}
        <h2>{entry.title}</h2>
        <p dangerouslySetInnerHTML={{ __html: content }} />
        {!entry.isTop && (
          <Link to={moreLink} className={styles.more}>
            Weiterlesen
          </Link>
        )}
        {entry.isTop && (
          <div className={styles.button}>
            <Button href={moreLink} label="Mehr erfahren" />
          </div>
        )}
      </ChessboardItem>
    );
  }

  render() {
    const { newsList } = this.state;
    const { deeplinkId } = this.props;

    return (
      <Fragment>
        {newsList.items.length === 0 && (
          <IntroText title="Zurzeit sind keine News oder Events vorhanden" />
        )}
        <Chessboard deeplinkId={deeplinkId}>
          {newsList.map((entry, index) => this.rendenEntry(entry, index))}
        </Chessboard>
      </Fragment>
    );
  }
}
